import { render, staticRenderFns } from "./ancientPrison.vue?vue&type=template&id=1ae94e99&"
import script from "./ancientPrison.vue?vue&type=script&lang=js&"
export * from "./ancientPrison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports